import Cookies from 'js-cookie';

const API_ADMIN_URL = `https://kuchaknig02.b.litres.ru/`;

const ADMIN_FIRST_PAGE_URL = '/satellites-admin-panel/books/promotion-block/';
const ADMIN_AUTH_PAGE_URL = '/satellites-admin-panel/auth/';

const adminToken = Cookies.get('admin-token');

const requestConfigFormData = {
  headers: {
    'Content-Type': 'multipart/form-data',
  },
};

const requestConfigTokenFormData = {
  headers: {
    'Content-Type': 'multipart/form-data',
    Authorization: `${adminToken}`,
  },
};

const requestConfig = {
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    Authorization: `${adminToken}`,
  },
};

export { API_ADMIN_URL, requestConfigFormData, requestConfigTokenFormData, requestConfig, ADMIN_FIRST_PAGE_URL, ADMIN_AUTH_PAGE_URL };
